import { RouteHandler } from 'wee-routes';
import $events from 'wee-events';
import $screen from 'wee-screen';
import $mediator from 'wee-mediator';
import $ from 'wee-dom';
import innerHeight from 'ios-inner-height';
import MobileNavigation from './mobile';
import MobileSearch from '../search/mobile';
import DesktopNavigation from './desktop';
import DesktopSearch from '../search/desktop';
import KeyHelper from '../../scripts/keyhelper';

window._innerHeight = innerHeight;

class Navigation {
    initMobile() {
        const nav = new MobileNavigation();
        const search = new MobileSearch();

        this.mobileNav = nav;
        this.mobileSearch = search;

        $(':navigationPanelBottomAction').css({
            bottom: `calc(100vh - (${innerHeight()} + 49))`,
        });

        $events.on({
            [search.$button.sel]: {
                click: () => {
                    nav.close();
                    search.toggle();
                },
            },
            [nav.$button.sel]: {
                click: () => {
                    search.close();
                    nav.toggle();
                },
            },
            [nav.$links.sel]: {
                click(e, el) {
                    nav.slideTo($(el).data('type'));
                },
            },
            [nav.$backButton.sel]: {
                click: () => nav.slideBack(),
            },
            [nav.$navigationSections.sel]: {
                transitionend: (e, el) => {
                    if (e.target === el) {
                        nav.focusBackButton();
                    }
                },
            },
            body: {
                keyup(e) {
                    if (KeyHelper.isEsc(e)) {
                        if (nav.isOpen) {
                            nav.close();
                        }
                    }
                },
            },
        }, {
            namespace: 'mobileNavigation',
        });

        // Close the navigation if the skip to content link is activated
        $mediator.on('global.skipToContent', () => {
            nav.close();
            search.close();
        });
    }

    destroyMobile() {
        if (this.mobileNav) {
            this.mobileNav.close();
        }

        $events.off(null, '.mobileNavigation');
    }

    initDesktop() {
        const nav = new DesktopNavigation();
        const search = new DesktopSearch();

        this.desktopNav = nav;

        $events.on({
            [search.$closeButton.sel]: {
                click() {
                    search.close();
                },
            },
            [search.$button.sel]: {
                click() {
                    search.toggle();
                },
            },
            [nav.$closeButton.sel]: {
                click() {
                    nav.close();
                },
                keyup(e) {
                    if (KeyHelper.isEnter(e)) {
                        nav.close();
                    }
                },
            },
            [nav.$links.sel]: {
                click(e, el) {
                    nav.togglePanel($(el).data('type'));
                },
                keyup(e) {
                    const keyMap = {
                        ArrowRight: 'nextPanel',
                        ArrowLeft: 'prevPanel',
                        Escape: 'close',
                    };

                    if (Object.keys(keyMap).includes(e.key)) {
                        nav[keyMap[e.key]]();
                    }
                },
            },
        }, {
            namespace: 'desktopNavigation',
        });

        $mediator.on('search.desktop.close', () => {
            if (search.isOpen) {
                search.close();
            }
        });
    }

    destroyDesktop() {
        $events.off(null, '.desktopNavigation');
    }
}

export default new RouteHandler({
    init() {
        const nav = new Navigation();

        $screen.map([
            {
                max: 3,
                callback() {
                    nav.destroyDesktop();
                    nav.initMobile();
                },
            },
            {
                min: 4,
                callback() {
                    nav.destroyMobile();
                    nav.initDesktop();

                    if (nav.mobileSearch) {
                        nav.mobileSearch.close();
                    }
                },
            },
        ]);
    },
});
